import { SelfServeSignupValues, SelfServeSignupRequest } from './types';

type TransformedFormValues = Omit<SelfServeSignupRequest, 'tags' | 'woltUid'>;

export const formValuesToApi = (formValues: SelfServeSignupValues): TransformedFormValues => {
  const {
    phoneNumber: formPhoneNumber,
    venues: formVenues,
    firstName: formFirstName,
    lastName: formLastName,
    name: formBusinessName,
    email: formEmail,
    businessId: formBusinessId,
    businessType: formBusinessType,
  } = formValues;

  const isNonWoltCity = !formValues.venues.isWoltCity;

  const venue = {
    name: formVenues.name.trim(),
    address: formVenues.address.trim(),
    postCode: formVenues.postCode.trim(),
    city: isNonWoltCity ? formValues.venues.otherCity?.trim() : formVenues.city.trim(),
    isWoltCity: formVenues.isWoltCity,
  };

  const firstName = formFirstName.trim();
  const lastName = formLastName.trim();
  const name = formBusinessName.trim();
  const email = formEmail.trim();
  const phoneNumber = `${formPhoneNumber.extension}${formPhoneNumber.number.trim()}`;
  const venues = [venue];
  const businessId = formBusinessId.trim();
  const businessType = formBusinessType.trim();
  const venueNumber = formVenues.venueNumber!;

  return {
    ...formValues,
    firstName,
    lastName,
    name,
    phoneNumber,
    email,
    venues,
    venueNumber,
    businessId,
    businessType,
  };
};
